module.exports = __webpack_public_path__ + "d0e8fc2d8824ff4904e7b28cbcf53f12.svg";